import { render } from "./overlay.vue?vue&type=template&id=ff801ed0&scoped=true"
import script from "./overlay.vue?vue&type=script&lang=js"
export * from "./overlay.vue?vue&type=script&lang=js"

import "./overlay.vue?vue&type=style&index=0&id=ff801ed0&scoped=true&scss=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff801ed0"]])

export default __exports__